import { LoadableAfterPaint } from '@confluence/loadable';
import type { SatisfactionSurveyComponentProps } from '../src/SatisfactionSurveyComponent';
export type { OnInteractionData } from '../src/SatisfactionSurveyComponent';

export const SatisfactionSurveyComponent = LoadableAfterPaint<SatisfactionSurveyComponentProps>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SatisfactionSurveyComponent" */ '../src/SatisfactionSurveyComponent'
			)
		).SatisfactionSurveyComponent,
});
